import styles from './footer.module.scss';
import AdventureImage480 from '../../assets/footer-adventure-v1-480.webp';
import AdventureImage960 from '../../assets/footer-adventure-v1-960.webp';
import FilledButton from '../../components/filled-button';
import { useNavigate } from 'react-router-dom';
const UpperBody = () => {
  const navigate = useNavigate();
  return (
    <div className={` ${styles.upper__body}`}>
      <div className={styles.upper__body__image}>
        {/* <div className={styles.dashed__prop} /> */}
        <div/>
        <img
          src={AdventureImage960}
          srcSet={`${AdventureImage480} 480w, ${AdventureImage960} 960w`}
          sizes='(max-width: 640px) calc(100vw - 32px), 50vw'
          alt='A trekking backpack beside a Himalayan trail at sunrise'
          width='1280'
          height='960'
          loading='lazy'
          decoding='async'
        />
      </div>
      <div className={styles.upper__body__content}>
        <div className={styles.title}>Plan your route with our Nepal team</div>
        <div className={styles.description}>
          Share your dates, group size and preferred route. We will reply with
          practical next steps and a written quotation after checking the current
          operating conditions.
        </div>
        <div
          className='cursor-pointer'
          onClick={() => {
            navigate('/contact');
          }}
        >
          <FilledButton text='Enquire' />
        </div>
      </div>
    </div>
  );
};

export default UpperBody;
